const ANTD = require('./antd.config')
const setting = require('./setting.config')

module.exports = {ANTD, setting}
